// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5d4008b3","455":"a86527e4"}[chunkId] + ".chunk.js";
};